// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.


require("@rails/ujs").start()
require("turbolinks").start()
require("@rails/activestorage").start()
require("channels")
require("@fancyapps/fancybox/dist/jquery.fancybox")
require("@fortawesome/fontawesome-free/js/all")
document.addEventListener('DOMContentLoaded', function(e){
  document.addEventListener('contextmenu', e => e.preventDefault())
  document.onkeydown =  function (e){
      if(e.ctrlKey && (e.keyCode === 85)){
      }
      return false
  }
  if(document.querySelectorAll('.call-mobile-bottom-fixed a').length == 1){ 
    document.querySelectorAll('.call-mobile-bottom-fixed a')[0].classList.add('button-vw')
  }
require("jquery/dist/jquery")
require("./fancyBox")
require("./loadLazyImage")
require("./menuButtonMobile")
require("./playVideo")
});
